import $ from "jquery";

function stopEvents(e) {
  e.preventDefault();
  e.stopPropagation();
}

export function preventScrolling() {
  $window = $(window);
  $window.bind("mousewheel DOMMouseScroll wheel", stopEvents);

  scrollX = $window.scrollLeft();
  scrollY = $window.scrollTop();
  window.onscroll = () => window.scrollTo(scrollX, scrollY);
}

export function enableScrolling() {
  $window = $(window);
  $window.unbind("mousewheel DOMMouseScroll wheel", stopEvents);

  window.onscroll = null;
}
